import request from '@/utils/request'

export function getConfig(params) { 
    return request({
        url: '/homeapi/homewallnewspaper/getConfig',
        method: 'get',
        params
    })
}
export function getEventInfo(params) { 
    return request({
        url: '/homeapi/manage/getEventInfo',
        method: 'get',
        params
    })
}
export function getCategoryList(params) { 
    return request({
        url: '/homeapi/homewallnewspaper/getCategoryList',
        method: 'get',
        params
    })
}
export function getLiteratureList(params) { 
    return request({
        url: '/homeapi/homewallnewspaper/getLiteratureList',
        method: 'get',
        params
    })
}
export function addLiterature(data) {
    return request({
        url: '/homeapi/homewallnewspaper/addLiterature',
        method: 'post',
        data
    })
}
export function getCategoryLists(params) {
    return request({
        url: '/adminapi/wallnewspaper/getCategoryList?',
        method: 'get',
        params
    })
}
export function uploadFile(data) {
    return request({
        url: '/homeapi/homewallnewspaper/uploadFile',
        method: 'post',
        data
    })
}
// 点赞
export function upvote(data) {
    return request({
        url: '/homeapi/Homewallnewspaper/upvote',
        method: 'post',
        data
    })
}
// 壁报详情
export function getLiteratureInfoNew(params) {
    return request({
        url: '/homeapi/Homewallnewspaper/getLiteratureInfoNew',
        method: 'get',
        params
    })
}
// 取消点赞
export function cancelUpvote(data) {
    return request({
        url: '/homeapi/Homewallnewspaper/CancelUpvote',
        method: 'post',
        data
    })
}
/**
 * 获取活动通知
 * params 
 */
export function getSystemEnDis (params) {
    return request({
      url: '/homeapi/Microsite/getSystemEnDis',
      method: 'get',
      params
    })
  }



export function wxshare (params) {
    return request({
      url: '/jssdk.php',
      method: 'get',
      params
    })
  }

  // 判断活动是否有效
export function getEventOrgStatus (params) {
    return request({
        url: '/adminapi/Event/getEventOrgStatus',
        method: 'get',
        params
    })
  }